import * as Yup from 'yup';
import { DateUtil, FormValidationUtil } from '../../../utils';

export const detailedTimesheetIninitialValues = {
  subject: '',
  startDate: '',
  endDate: '',
  startTime: '',
  endTime: '',
  comments: '',
  allDay: false,
};

export const detailedTimesheetValidationSchema = Yup.object().shape({
  subject: Yup.string().required('Subject is required'),
  startDate: Yup.string().required('From date is required'),
  endDate: Yup.string()
    .required('To date is required')
    .test(
      'is-same-as-from-date',
      'To date must be same as From date',
      FormValidationUtil.endDateSameAsStartDate('fromDate'),
    ),
  startTime: Yup.string()
    .required('From time is required')
    .test(
      'is-before-toTime',
      'From Time must be before To Time',
      FormValidationUtil.fromTimeBeforeToTime('toTime'),
    ),
  endTime: Yup.string()
    .required('To time is required')
    .test(
      'is-after-fromTime',
      'To Time must be after From Time',
      FormValidationUtil.toTimeAfterFromTime('fromTime'),
    ),
  comments: Yup.string(),
});

export const populateFormData = eventInData => {
  const formEditData = {
    subject: eventInData?.Subject,
    startDate: eventInData?.StartDate
      ? DateUtil.formatDateTimeToHtmlDate(eventInData.StartDate)
      : '',
    endDate: eventInData?.EndDate
      ? DateUtil.formatDateTimeToHtmlDate(eventInData.EndDate)
      : '',
    startTime: eventInData?.StartTime
      ? DateUtil.formatDateTimetoHtmlTime(eventInData.StartTime)
      : '',
    endTime: eventInData?.EndTime
      ? DateUtil.formatDateTimetoHtmlTime(eventInData.EndTime)
      : '',
    comments: eventInData?.Comments,
    allDay: eventInData?.AllDay,
  };
  return formEditData;
};
